// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfYear as fn } from "../endOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfYear;
